import { DateStr, GetPntScheduleDto, Paginated } from '@mi-front/core';
import { apiClient } from '../../../../../../../../api';
import { getAuditListingDefaultDate } from '@app/modules/audit/modules/station-audit/helpers/default-listing-date-range';
import { ReportView } from '../../../../../../../../core/reports/components/ReportView';
import { ReportType } from '../../../../../../../../core/reports/types';
import { SchedulesListMentionsIndexForm } from './SchedulesListMentionsIndexForm';
import { SchedulesListMentionsIndexResult } from './SchedulesListMentionsIndexResult';
import { Station } from '@app/core/types/stations';

type Props = {
  station: Station;
};

export type SchedulesMentionsIndexListing = ReportType<
  { date: DateStr },
  Paginated<GetPntScheduleDto>
>;

export function MentionsIndexView(p: Props) {
  return (
    <ReportView<SchedulesMentionsIndexListing>
      defaultValues={{
        date: getAuditListingDefaultDate(),
      }}
      runOnLoad
      download={false}
      reportFn={async (values) => {
        return apiClient.audit.fetchMentionsDateSchedules({
          ...values,
          stationId: p.station.id,
          filter: {
            date: values.date,
          },
        });
      }}
      Form={SchedulesListMentionsIndexForm}
      Result={SchedulesListMentionsIndexResult}
    />
  );
}
